import * as React from 'react';
import { connect } from "react-redux";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

const DATE_FORMAT = Tools.getDateFormats();


class LocationInfo  extends React.Component {
    constructor(props) {
        super(props);
        const { visit } = props;
        const departmentId = visit && visit.department && visit.department.id ? visit.department.id : '';
        const departmentIdType = visit && visit.department && visit.department.idType ? visit.department.idType : '';
        const preSelectedValue = departmentId ? departmentId + "|" + departmentIdType : '';
        this.state= {
            validationError: '',
            selectedDepartment: {
                isDepartmentSelected: false,
                label: visit && visit.department && visit.department.name ? visit.department.name : '',
                value: preSelectedValue
            }
        }
        this.locationSelected = this.locationSelected.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.LocationInfo.ComponentDidMount", new Date(), Tools.getURLPath());
        this.mounted = true;
    }

    isValid() {
        return this.isValidate();
    }

    locationSelected = (department) => {
        this.setState({
            showAsInvalid: false,
            selectedDepartment: {
                isDepartmentSelected: true,
                label: department && department.label ? department.label : '',
                value: department && department.value ? department.value : ''
            }
        });
    }
    isValidate() {
        const { selectedDepartment } = this.state;
        if (!selectedDepartment.isDepartmentSelected) {
            this.setState({ validationError: "Please select location."});
            return false;
        }
        return true;
    }

    onGoNext(success) {
        const { selectedDepartment } = this.state;
        const { visit, routeTime ,enableOpenScheduling, departments} = this.props;
        if (!success) {
            this.setState({ showAsInvalid: true });
        }
        let todayDate = new Date();
        let routeDate = this.props.routeDate ? this.props.routeDate : `${todayDate.getFullYear()}-${todayDate.getMonth() + 1}-${todayDate.getDate()}`
        if (selectedDepartment && visit.department.name !== selectedDepartment.label && selectedDepartment.value) {
            const id = selectedDepartment.value.split("|")[0];
            const type = selectedDepartment.value.split("|")[1];
            
            const newDepartmentId = visit.department.id;
            const departmentArray =  newDepartmentId  && newDepartmentId.split('|');
            const departmentFilter = departmentArray && departmentArray.filter(val => val === id );

            if (id && type) {
                visit.department.id = (departmentFilter.length && this.props.enableNewProviderSchedulingWorkflow) ? departmentFilter.toString() : id;
                visit.department.name = selectedDepartment ? selectedDepartment.label : "";
                visit.department.idType = type;
            }
            let startDate = Tools.toJSDate(`${routeDate} 00:00:00`, DATE_FORMAT);
            let dtEnd = Tools.getEndOfMonth(startDate.getFullYear(), startDate.getMonth());
            let endDate = `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`
            visit.date = this.props.routeDate ? this.props.routeDate : '';
            visit.time = routeTime ? routeTime : "";
            this.props.saveStepInfo({ visit: visit, startDate: routeDate, endDate }, true);
        } else {
            this.props.saveStepInfo({visit: visit}, true);
        }
        logUI("MBHWeb.UI.LocationInfo.Continue.Clicked", new Date(), Tools.getURLPath(), { visit: visit });
    }

    render() {
        const { departments, visit,enableNewProviderSchedulingWorkflow } = this.props;
        const { selectedDepartment, showAsInvalid, validationError } = this.state;
        let newDepartment = [];
        if(enableNewProviderSchedulingWorkflow) {
           
            const newDepartmentId = this.props.newDepartArray;
            for (let val of departments) {
                let deptId = newDepartmentId && newDepartmentId.filter(id => id === val.value.split("|")[0]);
                if (val.value.split("|")[0] === deptId.toString()) {
                    newDepartment.push(val);
                }
            }
        } else {
            newDepartment = departments;
        }
        
        
        return (
            <div className="row select-location-info-container text-center" style={this.props.style}>
                    <div className="col-12 text-center">
                        <div className="select-patient-title">
                            <div className="item-img-container">
                                <img className="img-vist-type" alt={"provider-photo"} src={"/images/location.svg"} />
                            </div>                            
                                <h1 className="step-head">Select an office location</h1>
                        </div>
                    </div>
                    <div className="col-12 select-location-card-container">
                        {newDepartment && newDepartment.length > 0 &&
                            newDepartment.map((department, index) =>
                                <div className="location-card" key={index}>
                                    <div className="card">
                                        <div className={(selectedDepartment.isDepartmentSelected && department.value.indexOf(selectedDepartment.value) > -1) ? "location-info-card-selected" : "location-info-card-unselected"}>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <ul className="select-location-ul">
                                                            <li>
                                                                <label className="location-radio-btn-container">
                                                                    <input
                                                                        type="radio"
                                                                        id={"radio_btn_id_" + department.value}
                                                                        name={"radio_btn_" + department.value}
                                                                        checked={selectedDepartment.isDepartmentSelected && department.value.indexOf(selectedDepartment.value) > -1}
                                                                        onChange={e => this.locationSelected(department)}
                                                                    />
                                                                    <span className="location-radio-btn" />
                                                                    <div className="location-radio-label">
                                                                        {department ?
                                                                            <div className="details-col">
                                                                                <div className="location-radio-btn-label">{department && department.label ? department.label : "-"}</div>
                                                                                <div className="location-radio-btn-sublabel">{department && department.label2 ? department.label2 : "-"}</div>
                                                                            </div> :
                                                                            <React.Fragment>
                                                                                <div className="details-col">
                                                                                    <div className="no-data-dash">
                                                                                        <div />
                                                                                    </div>
                                                                                </div>
                                                                            </React.Fragment>
                                                                        }
                                                                    </div>
                                                                </label>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        )}
                    </div>
                    <div>
                    {(showAsInvalid && validationError !== "") &&
                        <div className="text-center validation-error-container">
                            <div className="error-msg">{validationError}</div>
                        </div>
                    }
                    </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(LocationInfo);
